import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c0a9540"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "billing-restriction-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "billingRestrictionTitle"
}
const _hoisted_2 = { class: "billing-restriction-modal__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-close" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "billing-restriction-modal__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  id: "billingRestrictionTitle",
  class: "billing-restriction-modal__title"
}, " Cadastro inativo ", -1))
const _hoisted_7 = { class: "billing-restriction-modal__message" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_LogoutModal = _resolveComponent("LogoutModal")!
  const _component_CoupleToolbar = _resolveComponent("CoupleToolbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app", {'mosaic-page': _ctx.currentRoute == '/chat'}])
  }, [
    (_ctx.billingRestrictionMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "billing-restriction-modal__backdrop",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissBillingRestrictionMessage && _ctx.dismissBillingRestrictionMessage(...args)))
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "billing-restriction-modal__close",
              "aria-label": "Fechar",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismissBillingRestrictionMessage && _ctx.dismissBillingRestrictionMessage(...args)))
            }, _hoisted_4),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.billingRestrictionMessage), 1),
            _createElementVNode("button", {
              type: "button",
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 w-100",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dismissBillingRestrictionMessage && _ctx.dismissBillingRestrictionMessage(...args)))
            }, " Entendi ")
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.isLogged && _ctx.currentRoute !== '/' && _ctx.currentRoute !== '/chat')
            ? (_openBlock(), _createBlock(_component_MainHeader, {
                key: 0,
                onRequestLogout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logoutModalOpen = true))
              }))
            : _createCommentVNode("", true),
          (_ctx.isLogged && _ctx.currentRoute !== '/' && !_ctx.mobileChatOpen)
            ? (_openBlock(), _createBlock(_component_MainSidebar, {
                key: 1,
                onRequestLogout: _cache[4] || (_cache[4] = ($event: any) => (_ctx.logoutModalOpen = true))
              }))
            : _createCommentVNode("", true),
          (_ctx.isLogged && _ctx.currentRoute !== '/')
            ? (_openBlock(), _createBlock(_component_LogoutModal, {
                key: 2,
                open: _ctx.logoutModalOpen,
                onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.logoutModalOpen = false))
              }, null, 8, ["open"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["main-content d-flex flex-column transition overflow-hidden custom-chat-page-style", {'center-main-content': !_ctx.isLogged, 'justify-content-start validate-home-page': _ctx.currentRoute === '/', 'attendants-day-main': _ctx.currentRoute === '/attendants-day', 'chat-main': _ctx.currentRoute === '/chat', 'mobile-chat-open': _ctx.mobileChatOpen, 'with-mobile-bottom-nav': _ctx.isLogged && _ctx.currentRoute !== '/'}])
          }, [
            (_ctx.isLogged)
              ? (_openBlock(), _createBlock(_component_CoupleToolbar, { key: 0 }))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_component_router_view, {
              key: `${_ctx.currentRoute}:${_ctx.getAccountViewRevision}`
            })),
            (_ctx.isLogged && _ctx.currentRoute !== '/' && _ctx.currentRoute !== '/chat')
              ? (_openBlock(), _createBlock(_component_MainFooter, { key: 1 }))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}